<template>
  <div class="header">
    <div class="container">
      <div class="logo inline-block" @click="toHome()">
        <img src="../../assets/images/main/logo.png" alt="logo" width="100%;" />
      </div>
      <div class="navbar inline-block">
        <span
          class="nav-item inline-block"
          v-for="(item, index) in $t('menu')"
          :key="index"
          @click="handle(index)"
        >
          <span :class="['nav-link', index === active ? 'active' : '']" v-if="$i18n.locale === 'en'" style="font-size: 10px">{{
            item.text
          }}</span>
          <span :class="['nav-link', index === active ? 'active' : '']" v-else>{{
            item.text
          }}</span>
          <div class="hover-line" v-show="index === active && $i18n.locale !== 'en'"></div>
        </span>
      </div>
      <div class="location-selector" @click="show = !show">
        <img src="../../assets/images/main/language.png" />
        <span>{{ option.text }}</span>
        <div class="icon"></div>
      </div>
      <div class="selector-option" v-show="show">
        <div
          :class="['option', index === option.index ? 'active' : '']"
          v-for="(item, index) in options"
          :key="index"
          @click="handleSelect(index, item)"
        >
          {{ item.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {},
  data () {
    return {
      show: false,
      menu: [],
      options: [
        { value: 'ch', text: '简体中文' },
        { value: 'zh', text: '繁体中文' },
        { value: 'en', text: 'English' }
      ],
      active: null,
      option: {
        index: 0,
        text: '简体中文'
      }
    }
  },
  methods: {
    toHome () {
      this.active = null
      this.$router.push({ name: 'home' })
    },
    handle (index) {
      if (Number(index) === 6) {
        window.open('https://www.myutopa.com/m/mall/#/pages/help-center/common-problem/index?theme=%23ff445e&appType=2&proTypeId=14')
        return
      }
      const page = index + 1
      this.active = index
      this.$router.push({ path: `/page/${page}` })
    },
    handleSelect (index, item) {
      this.option = {
        index,
        text: item.text
      }
      this.$i18n.locale = item.value
      this.show = false
    }
  },
  computed: {}
}
</script>

<style lang="scss" scoped>
.header {
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 80px;
  line-height: 80px;
  background: #ffffff;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.1);
  .container {
    width: 80%;
    min-width: 900px;
    margin: 0 auto;
    position: relative;
    .location-selector {
      position: absolute;
      right: 0;
      cursor: pointer;
      img {
        position: relative;
        top: 4px;
        right: 10px;
      }
      .icon {
        display: inline-block;
        width: 5px;
        height: 5px;
        transform: rotate(45deg);
        border: 1px soild #d8d8d8;
        border-right: 2px solid #d8d8d8;
        border-radius: 1px;
        border-bottom: 2px solid #d8d8d8;
        position: relative;
        left: 10px;
        bottom: 3px;
      }
    }
    .selector-option {
      z-index: 999;
      background: #ffffff;
      position: absolute;
      right: -20px;
      top: 80px;
      line-height: 50px;
      padding: 0 20px;
      .option {
        cursor: pointer;
      }
      .option.active {
        color: #ff4a2a;
      }
    }
    .logo {
      position: absolute;
      top: 15px;
      cursor: pointer;
      width: 140px;
      height: 52px;
    }
    .navbar {
      position: absolute;
      left: 160px;
      height: 80px;
      .nav-item {
        position: relative;
        margin: 0 20px 0 10px;
        font-size: 14px;
        color: #617374;
        white-space: nowrap;
        text-overflow:ellipsis;
        overflow: hidden;
        cursor: pointer;
        .nav-link.active {
          color: #ff4a2a;
        }
        .hover-line {
          height: 3px;
          width: 20px;
          background: #ff4a2a;
          border-radius: 8px;
          position: absolute;
          bottom: 18px;
          left: 21px;
        }
      }
    }
  }
}
</style>
